export default __webpack_public_path__ + "static/media/MailW.edb92705.svg";